export const NOTIFICATION_TYPES = {
  info:    { label: 'Info',    bg: '#e1effe', fg: '#1e429f', tone: 'info' },
  warning: { label: 'Warning', bg: '#fef3c7', fg: '#92400e', tone: 'warning' },
  update:   { label: 'Update',   bg: '#def7ec', fg: '#03543f', tone: 'success' },
  activity: { label: 'Activity', bg: '#ede9fe', fg: '#5b21b6', tone: 'info' },
}

export const NOTIFICATION_TYPE_ORDER = ['info', 'update', 'warning', 'activity']
